module.exports = new Promise(resolve => {
    var cacheBuster = Date.now().toString(36)
    var src = 'https://insights.prisma.voya.io/remoteEntry.js?v=' + cacheBuster
    var script = document.createElement('script')
    script.src = src
    script.onload = function () {
      resolve(window.dashboard)
    }
    script.onerror = function () {
      console.error('Failed to load dashboard microfrontend from: ' + src)
      resolve(null)
    }
    document.head.appendChild(script)
  });